import SectionHeader from "../../../util/component/SectionHeader";
import {Box} from "@mui/material";
import OperatorSearch from "../component/OperatorSearch";
import OperatorTable from "../component/OperatorTable";
import {useTranslation} from "react-i18next";
import CustomContentWrapper from "../../../util/component/CustomContentWrapper";
import {useHasScope} from "../../../config/globalConfig";
import NotAuthorizedDialog from "../../authentication/component/NotAuthorizedDialog";

const OperatorList = () => {
    const {t} = useTranslation(['operator']);
    const hasScope = useHasScope;

    return (
        <Box>
            <SectionHeader title={t('label.operatorList')}/>
            <CustomContentWrapper>
                {hasScope('SCOPE_VIEW_OPERATOR') ?
                    <>
                        <OperatorSearch/>
                        <OperatorTable/>
                    </>
                    : <NotAuthorizedDialog/>}
            </CustomContentWrapper>
        </Box>
    );
}

export default OperatorList;
